export enum OpenGateTypeEnum {
  Immediately = 'immediately',
  LightSensor = 'light_sensor',
  XovisCamera = 'xovis_camera',
}
